import React, { forwardRef } from 'react';

import { InputProps } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import { AppTimeInput } from '../inputs/AppTimeInput';

interface Props extends InputProps {
  name: string;
}

export const AppManualTimeInput = forwardRef((props: Props, ref) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field }) => <AppTimeInput value={field.value} onChange={value => field.onChange(value)} />}
    />
  );
});
